export enum AuthState {
  SIGN_IN = 'signIn',
  SIGN_UP = 'signUp',
  FREE_SIGN_UP = 'freeSignUp',
  MICROPHONE_SIGN_UP = 'microphoneSignUp',
  SIGNED_IN = 'signedIn',
}
